module.exports = __webpack_public_path__ + "static/media/closingGap_desktop.b0d8a258.jpg";